"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _keyframes = require("./keyframes");

var _shapeWrapper = _interopRequireDefault(require("./shapeWrapper"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    animation: ", "\n        ", " linear calc(", " / 2)\n        ", " backwards;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ShapeWrapperNext = (0, _styledComponents["default"])(_shapeWrapper["default"])(_templateObject(), function (props) {
  return props.animationName || (props.column ? _keyframes.shapeColumn : _keyframes.shape);
}, function (props) {
  return props.duration;
}, function (props) {
  return props.duration;
}, function (props) {
  return props.infinite ? 'infinite' : props.theme.palette.transitionDuration;
});
var _default = ShapeWrapperNext;
exports["default"] = _default;